module.exports = __webpack_public_path__ + "static/media/charge-asset-market.8ad65bb4.png";